// extracted by mini-css-extract-plugin
export default {"SupportModalContainer":"styles_SupportModalContainer__u+OoC","title":"styles_title__cmQtn"};